import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import AppFellowship from './features/fellowship/AppFellowship';
import AppPapiKostick from './features/papikostick/AppPapiKostick';
import AppContact from './features/contact/AppContact';
import AppWaiting from './features/waiting/AppWaiting';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <React.StrictMode>
        {/* <AppFellowship /> */}
        {/* <AppPapiKostick /> */}
        <AppContact />
        {/* <AppWaiting /> */}
    </React.StrictMode>
);

reportWebVitals();
